import { Component, h, Prop, Element, State } from '@stencil/core';
import { guid } from 'utils';

@Component({
  tag: 'kdx-pageselector',
  styleUrl: 'kdx-pageselector.scss',
  shadow: false,
})
export class PageSelector {
  @Element() root: HTMLElement;

  /**
   * Large text that goes to the left dropdown
   */
  @Prop() selectorTitle: string;

  /**
   * Text on button
   */
  @Prop() buttonText: string = 'Go';

  /**
   * Placeholder text for custom select
   */
  @Prop() dropdownText: string;

  /**
   * The name attribute of the select tag
   */
  @Prop() selectName: string;
  
  /**
	 * The dropdown icon
	 */
	@Prop() selectIcon: string = "chevron-down";

  /**
   * Default option, not a selectable. If none, display first option in its place.
   */
  @Prop() defaultOption?: string;

  /**
	 * The ID of the select tag
	 */
	@Prop({
		mutable: true,
		reflect: true
	}) selectId: string;

  /**
	 * Generated GUID for toggling custom dropdown
	 */
	@State() guid: string = guid();


  /**
   * Function runs when button is clicked, opens chosen page
   *
   * @param e - event
   */
  goToPage(e) {
    e.preventDefault();
    const pageUrl = (document.getElementById(this.selectId) as HTMLSelectElement).value;
    
    window.location.href = pageUrl;

  }

  componentWillLoad() {
		// Create unique ID
		this.selectId = (!this.selectId) ? "kdx-dropdown-list-" + this.guid : this.selectId;
  }

  render() {
    return (
      <div class="kdx-pageselector">
        <div class="kdx-pageselector__inner">
          {Boolean(this.selectorTitle) && <div class="kdx-pageselector__title">{this.selectorTitle}</div>}
          <div class="dropdown-wrapper">
            <kdx-dropdown-list 
              class="homepage-pageselector"
              dropdown-text={this.dropdownText} 
              select-name={this.selectName}
              select-icon={this.selectIcon}
              select-id={this.selectId}>
              <slot />
            </kdx-dropdown-list>
          </div>
          <button
            class="btn btn-primary"
            aria-label={this.buttonText}
            onClick={e => {
              this.goToPage(e);
            }}
          >
            {this.buttonText}
          </button>
        </div>
      </div>
    );
  }
}
